interface QuizProgressProps {
  currentStep: number;
  totalSteps: number;
}

export default function QuizProgress({ currentStep, totalSteps }: QuizProgressProps) {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="quiz-progress">
      <div className="quiz-progress__bar">
        <div
          className="quiz-progress__fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      <span className="quiz-progress__text">
        Step {currentStep} of {totalSteps}
      </span>
    </div>
  );
}
